
export const initialValues = {
  gradeName: "",
  gradeCode: "",
  activeStatus: 1,

}